import React from "react";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import TickIcon from "assets/img/svg/svgComponents/TickIcon";
import moment from "moment";
import { formattedPrice } from "views/pages/manage/unAssigned/collectPayment/utils";

const ApplyMiscChargesAlert = ({
  transferType,
  closeHandler,
  amount,
  timeStamp,
  isMscrChargesAlreadyApplied,
}) => {
  return (
    <div className="approval-sent-dialog p-2" style={{ width: "300x" }}>
      <span className="d-flex justify-content-center align-items-center tick-icon">
        <TickIcon />
      </span>
      <div className="header">
        Charges of {formattedPrice(amount)} have{" "}
        {isMscrChargesAlreadyApplied ? "already" : ""} been applied on{" "}
        {moment(timeStamp).format("DD-MMM-YYYY hh:mm A")} for {transferType}{" "}
        request
      </div>
      <AButton
        variant="primary_filled"
        onClick={() => closeHandler(false)}
        className="no-ml-btn w-25"
      >
        Okay
      </AButton>
    </div>
  );
};

export default ApplyMiscChargesAlert;
